import { useFileDownload } from '@/hooks/useFileDownload'
import { useLightMode } from '@/hooks/useLightMode'

import { Box, FileThumbnail } from '@hivewatch/dark'

import { RenderMediaFileIProps } from '../../../shared/types/feedTypes'
import { IncidentNoteVideoPlayer } from '../../components/IncidentNoteVideoPlayer'

export const RenderMediaFile = ({
  file,
  onFileClick,
}: RenderMediaFileIProps) => {
  const { name, url, mimeType } = file
  const { isDownloading, handleDownload } = useFileDownload()
  const colorScheme = useLightMode()

  const handleClick = () => {
    onFileClick(file)
  }

  // The type label comes from the mimeType, not the file name — note media
  // names are user-supplied and not guaranteed to carry an extension.
  if (mimeType?.startsWith('image/')) {
    return (
      <FileThumbnail
        colorScheme={colorScheme}
        extension={mimeType.includes('png') ? 'png' : 'jpg'}
        key={url}
        name={name}
        onClick={handleClick}
        previewSrc={url}
      />
    )
  } else if (mimeType === 'video/mp4' || mimeType === 'video/quicktime') {
    return (
      <Box key={url} onClick={handleClick}>
        <IncidentNoteVideoPlayer videoUrl={url} />
      </Box>
    )
  } else if (mimeType === 'application/pdf') {
    return (
      <FileThumbnail
        colorScheme={colorScheme}
        extension='pdf'
        key={url}
        name={name}
        onClick={handleClick}
      />
    )
  }

  // Formats the app cannot render inline are offered as a download
  return (
    <FileThumbnail
      colorScheme={colorScheme}
      isDownloading={isDownloading}
      key={url}
      name={name}
      onDownload={() => handleDownload(url, name)}
    />
  )
}
